import React, { useState } from 'react'
import { format } from 'date-fns'
import { Container, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Button, Icon, Popup, Pagination } from 'semantic-ui-react'

const ConsumersTable = ({ data, refreshClicked }) => {
    const [itemsPerPage] = useState(20)
    const [activePage, setActivePage] = useState(0)

    const renderPagination = () => {
        if (!data) return null
        const length = data.length
        const pagesRequired = Math.ceil(length / itemsPerPage)
        const siblingRange = window.innerWidth < 768 ? window.innerWidth < 465 ? 0 : 1 : 2
                return <Pagination size={window.innerWidth < 768 ? 'mini' : null} inverted defaultActivePage={1} totalPages={pagesRequired} siblingRange={siblingRange} onPageChange={handlePageChange}/>
    }

    const renderTableRows = () => {
        if (!data) return null
        const slicedData = data.slice(activePage * itemsPerPage, activePage * itemsPerPage + itemsPerPage)
        const rows = []
        for (const [i, order] of slicedData.entries()) {
            rows.push(
                <TableRow key={i}>
                    <TableCell textAlign='center'>
                        <Popup inverted wide trigger={<Icon inverted circular name="info" size="small" />} on='click' position="bottom left">
                            <span style={{ color: 'white' }}>{order.id}</span>
                        </Popup>
                    </TableCell>
                    <TableCell textAlign='center'>
                        <span style={{ color: 'white' }}>{beautifyStatusStr(order.status)}</span>
                        {showRefreshButtonForOrder(order) ? (
                            <Button inverted style={{ marginLeft: 10 }} size='tiny' circular basic icon onClick={() => refreshClicked(order)}>
                                <Icon inverted name="refresh" />
                            </Button>
                        ) : null}
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>{format(new Date(order.date), 'd MMM yyyy,  h:mm a')}</TableCell>
                    <TableCell style={{ color: 'white' }}>{order.game.replace('Mobile Legends', 'MLBB')}</TableCell>
                    <TableCell style={{ color: 'white' }}>{order.packageEDName}</TableCell>
                    <TableCell style={{ color: 'white' }}>
                        {order.userName}
                        <Popup inverted wide trigger={<Icon inverted circular name="info" size="small" />} on='click' position="bottom left">
                            <span style={{ color: 'white' }}>
                                User ID: {order.userID}<br />Server ID: {order.serverID}
                            </span>
                        </Popup>
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>
                        {order.item.replace('Diamonds', '💎')}
                        <Popup inverted wide trigger={<Icon inverted circular name="info" size="small" />} position="bottom left">
                            <span style={{ color: 'white' }}>Amount: ${order.amount}</span>
                        </Popup>
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>
                        {order.amount}
                        <Popup inverted wide trigger={<Icon inverted circular name="info" size="small" />} position="bottom left">
                            <span style={{ color: 'white' }}>Cost: {order.cost}</span>
                        </Popup>
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>{order.consumer.name}</TableCell>
                    <TableCell style={{ color: 'white' }}>{order.consumer.email}</TableCell>
                    <TableCell style={{ color: 'white' }}>{order.consumer.phone}</TableCell>
                </TableRow>
            )
        }
        return rows
    }

    const renderTable = () => {
        if (!data) return null
        return (
            <Table inverted style={{ overflowX: 'auto', display: 'block', whiteSpace: 'nowrap' }} size={window.innerWidth < 768 ? 'small' : null} unstackable>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCell>Date</TableHeaderCell>
                        <TableHeaderCell>Game</TableHeaderCell>
                        <TableHeaderCell>Package</TableHeaderCell>
                        <TableHeaderCell>User</TableHeaderCell>
                        <TableHeaderCell>Item</TableHeaderCell>
                        <TableHeaderCell>Amount</TableHeaderCell>
                        <TableHeaderCell>Customer Name</TableHeaderCell>
                        <TableHeaderCell>Email</TableHeaderCell>
                        <TableHeaderCell>Phone</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {renderTableRows()}
                </TableBody>
            </Table>
        )
    }

    const handlePageChange = (e, { activePage }) => {
        const page = activePage - 1
        setActivePage(page)
    }

    const showRefreshButtonForOrder = order => {
        return order.status === 'new' || order.status === 'pending'
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            {renderTable()}
            {renderPagination()}
        </Container>
    )
}

const beautifyStatusStr = status => {
    if (status === 'successful') return 'Success ✅'
    else if (status === 'pending-customer-payment') return 'Pending Payment'
    else if (status === 'payment-received-pending-disbursement') return 'Payment Received. Pending Processing'
    return status
}

export default ConsumersTable